export default "__VITE_ASSET__C0hKw1kW__"